import { render } from "./CartProducts.vue?vue&type=template&id=6b3b2856"
import script from "./CartProducts.vue?vue&type=script&lang=js"
export * from "./CartProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__